import { Root as RadioGroupRoot } from '@radix-ui/react-radio-group';
import type { RadioGroupProps } from '@radix-ui/react-radio-group';
import React from 'react';

export const RadioGroup = ({ children, ...rest }: RadioGroupProps) => (
  <RadioGroupRoot {...rest}>{children}</RadioGroupRoot>
);
